var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"procedures-container"},[_c('ProceduresTabPage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }